import { type ModuleConfig } from "/@/cool";

export default (): ModuleConfig => {
	return {
		views: [
			{
				path: "/openapi/api-key",
				component: () => import("./views/api-key.vue"),
				meta: {
					label: "API密钥",
					lang_key: "openapi_api_key"
				}
			}
		]
	};
};
